export const en = {
    choose: 'Select'
};
